<db-cdn-notice-section class="mb20" *ngIf="!hasDcvRecord"></db-cdn-notice-section>
<db-cdn-original-server></db-cdn-original-server>
<db-cdn-disable-enterprise class="mt20" [isNameServer]="isNameServer" *ngIf="!isMember"></db-cdn-disable-enterprise>
